import React, { createContext, useContext, useState } from "react";
import { CryptoProvider } from "./CryptoContext";
import { SessionProvider } from "./SessionContext";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // const [isNewChat, setIsNewChat] = useState(false);
  // const [selectedChatId, setSelectedChatId] = useState(null);
  // const [isChatStarted, setIsChatStarted] = useState(false);
  const [isSuggestionClicked, setIsSuggestionClicked] = useState(false);
  const [selectedLanguageData, setSelectedLanguageData] = useState({
    code: "hi",
    label: "Hindi (हिन्दी)",
  });

  return (
    <AppContext.Provider
      value={{
        // selectedChatId,
        // setSelectedChatId,
        // isNewChat,
        // setIsNewChat,
        // isChatStarted,
        // setIsChatStarted,
        isSuggestionClicked,
        setIsSuggestionClicked,
        selectedLanguageData, 
        setSelectedLanguageData
      }}
    >
      <SessionProvider>
        <CryptoProvider>
      {children}
      </CryptoProvider>
        </SessionProvider>
      
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
